import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import React, {
    forwardRef,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from 'react'
import { ProgressError } from './components/ui/ProgressError'

export const Test = () => {
    return <ProgressError msg={'Testings'} path="/merchant/calendar_v2/" />
}
